import styled from 'styled-components'

interface ExpenseTypeTileIconStyledProps {
  isActive: boolean
}

export const ExpenseTypeTileIconStyled = styled.div<ExpenseTypeTileIconStyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.theme.typography.pxToRem(48)};
  height: ${(props) => props.theme.typography.pxToRem(48)};
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
  position: relative;

  background-color: ${(props) =>
    props.isActive
      ? props.theme.colors.button.group.background.active
      : props.theme.colors.button.group.background.default};
  color: ${(props) =>
    props.isActive
      ? props.theme.colors.button.group.content.active
      : props.theme.colors.button.group.content.default};
`
